"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var operators_1 = require("rxjs/operators");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
var document_operations_service_1 = require("../../shared/services/api/document-operations.service");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var MetafieldControlComponent = /** @class */ (function () {
    function MetafieldControlComponent(languageService, localeService, kbService, classifierService, validationService, documentOperationsService) {
        this.languageService = languageService;
        this.localeService = localeService;
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.validationService = validationService;
        this.documentOperationsService = documentOperationsService;
        this.acceptableFieldValues = [];
        this.classifierViews = [];
        this.metaFieldType = idm_kb_service_client_js_1.MetaFieldType;
        // Private
        this._requiredMetaFieldIds = [];
        this._destroy$ = new Subject_1.Subject();
    }
    MetafieldControlComponent.prototype.ngOnInit = function () {
        var _this = this;
        var inputLanguages$ = this.languageService.getInputLanguages();
        var categoryRequiredMetaFieldIds$ = this.validationService.getCategoryRequiredMetaFieldIds(this.field.getMetaFieldId().getMetaCategoryId().getSystemName());
        var classifiersView$ = this.field.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER ?
            this.classifierService.loadClassifiersView(this.field.getCompoundCategorySystemName()).pipe(operators_1.map(function (values) {
                if (_this.acceptableFieldValues && _this.acceptableFieldValues.length) {
                    return values.filter(function (value) {
                        return _this.acceptableFieldValues.find(function (classifier) {
                            return classifier.getId() === value.getId();
                        });
                    });
                }
                return values;
            }))
            : of_1.of([]);
        this.nameFieldSystemName$ = this.field.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY ? this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(this.field.getCompoundCategorySystemName())).pipe(operators_1.map(function (metaCategory) {
            return metaCategory.getNameMetaFieldIds().length &&
                metaCategory.getNameMetaFieldIds()[0].getSystemName() || 'name';
        })) : of_1.of(null);
        var documentUrl$ = this.field.getType() === idm_kb_service_client_js_1.MetaFieldType.DOCUMENT
            ? this.documentOperationsService.getUrl(this.value.getProperty(this.field.getSystemName()).value, this.firstLevelCategoryId, this.firstLevelEntityId, this.firstLevelFieldId)
            : of_1.of('');
        var localeInfo$ = this.field.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE ?
            inputLanguages$.pipe(operators_1.switchMap(function (languages) {
                return _this.localeService.getLocaleInfo(languages[0].getId());
            })) : of_1.of(null);
        zip_1.zip(inputLanguages$, categoryRequiredMetaFieldIds$, classifiersView$, documentUrl$, localeInfo$)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (_a) {
            var languages = _a[0], categoryRequiredMetaFieldIds = _a[1], classifiersView = _a[2], documentUrl = _a[3], localeInfo = _a[4];
            _this.languages = languages;
            _this._requiredMetaFieldIds = categoryRequiredMetaFieldIds;
            _this.classifierViews = classifiersView;
            _this.documentUrl = documentUrl;
            _this.localeInfo = localeInfo;
        });
    };
    MetafieldControlComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    MetafieldControlComponent.prototype.getCellId = function () {
        return this.value.getId() + '-' + this.index;
    };
    MetafieldControlComponent.prototype.isFieldRequired = function (systemName) {
        return this._requiredMetaFieldIds.some(function (metaFieldId) { return metaFieldId.getSystemName() === systemName; });
    };
    MetafieldControlComponent.prototype.itemChanged = function (selectedId) {
        var _this = this;
        if (selectedId) {
            if (this.field.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER) {
                this.classifierService
                    .loadClassifier(this.field.getCompoundCategorySystemName(), selectedId)
                    .pipe(operators_1.takeUntil(this._destroy$))
                    .subscribe(function (classifier) {
                    _this.value.getProperty(_this.field.getSystemName()).value = classifier;
                }, console.error);
            }
            else {
                this.value.getProperty(this.field.getSystemName()).value =
                    this.acceptableFieldValues.find(function (entity) { return entity.getInstanceId() === selectedId; });
            }
        }
        else {
            this.value.getProperty(this.field.getSystemName()).value = null;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.SubEntity)
    ], MetafieldControlComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], MetafieldControlComponent.prototype, "acceptableFieldValues", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaField)
    ], MetafieldControlComponent.prototype, "field", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], MetafieldControlComponent.prototype, "readonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MetafieldControlComponent.prototype, "index", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MetafieldControlComponent.prototype, "firstLevelEntityId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MetafieldControlComponent.prototype, "firstLevelCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MetafieldControlComponent.prototype, "firstLevelFieldId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MetafieldControlComponent.prototype, "currentLanguageId", void 0);
    MetafieldControlComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-metafield-control',
            styles: [require('./metafield-control.component.css')],
            template: require('./metafield-control.component.html')
        }),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.LanguageService,
            idm_locale_service_client_js_1.LocaleService,
            idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_validation_calculation_service_client_js_1.ValidationService,
            document_operations_service_1.DocumentOperationsService])
    ], MetafieldControlComponent);
    return MetafieldControlComponent;
}());
exports.MetafieldControlComponent = MetafieldControlComponent;
//# sourceMappingURL=metafield-control.component.js.map